import { getConversationStatus } from "../conversation/conversationMapper";
import { InvoiceGateways, InvoiceStatus, InvoiceTypes } from "./invoiceConstants";

export function fixGetManyInvoices(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      invoiceId: resource.objectId,
      typeName: getType(resource.type),
      statusName: getStatus(resource.status),
      gatewayName: getGateway(resource.gateway),
    })),
  };
}

export function invoiceMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      invoiceId: resource.objectId,
      typeName: getType(resource.type),
      statusName: getStatus(resource.status),
      gatewayName: getGateway(resource.gateway),
      conversationStatusName:
        resource.conversationStatus === 0 || resource.conversationStatus === 1
          ? getConversationStatus(resource.conversationStatus)
          : "ایجاد نشده است",
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function invoiceMapperGetOneResponse(json) {
  json.result.gatewayDataName = json.result.gatewayData ? [json.result.gatewayData] : [];
  return {
    data: {
      ...json.result,
      id: json.result.objectId,
      typeName: getType(json.result.type),
      statusName: getStatus(json.result.status),
      gatewayName: getGateway(json.result.gateway),
      conversationStatusName:
        json.result.conversationStatus === 0 || json.result.conversationStatus === 1
          ? getConversationStatus(json.result.conversationStatus)
          : "ایجاد نشده است",
    },
  };
}

export function fixUpdateInvoiceId(json) {
  return {
    data: { ...json, id: json.objectId },
  };
}

export function getType(type) {
  console.log(type)
  return InvoiceTypes[type - 1].name;
}

export function getGateway(gateway) {
  return InvoiceGateways[gateway - 1].name;
}

export function getStatus(status) {
  return InvoiceStatus[status].name;
}
